// Error.js
import { Container, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#d32f2f', // A shade of red for errors
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

interface ErrorProps {
  message?: string;
}

export function Error({ message = "Unknown error" }: ErrorProps) {
  return (
    <ThemeProvider theme={theme}>
      <Container
        maxWidth="sm"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
          bgcolor: '#fff',
          borderRadius: 2,
          boxShadow: 3,
          padding: 3,
          marginTop: 4,
        }}
      >
        <Typography variant="h4" color="primary" gutterBottom>
          Oops! An Error Occurred
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          {message || "Something went wrong. Please try again later."}
        </Typography>
        <Box mt={3}>
          <Button variant="contained" color="primary" component={Link} to="/">
            Go Home
          </Button>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
